import React, { useState } from 'react';
import {
  DownChevronIcon,
  ExitIcon
} from '../../modules/Icons';
import { Dialog } from '@headlessui/react';
import {
  fixOptionTitle,
  optionablesToSpecs
} from '../../helpers/pages/collections/collectionsHelpers';
import { Icons } from '../../staticData/SpecsIcons';

export default function ProductSpecs(props) {
  const { collection } = props;
  const [specsOpen, setSpecsOpen] = useState(false);

  let specs = optionablesToSpecs(collection.collection_variants);
  specs = { Assets: [{ value: collection.elements, disclaimers: [] }], ...specs };

  const featuredSpecs = [
    'Assets',
    'Resolution',
    'Camera',
    'Alpha',
    'Alpha Channel',
    'Frame Rate',
    'Format',
    'Formats',
    'Auto Formats',
    'Render Passes',
    'Color Space'
  ];

  return (
    <div cy-test-id="product-specs">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 pt-4 gap-2">
        {Object.entries(specs)
          .filter((v) => featuredSpecs.includes(v[0]))
          .slice(0, 4)
          .map((v) => (
            <div className="flex gap-[6px]" key={v[0]}>
              <div className="w-[32px]">{Icons[v[0]]}</div>
              <div className="">
                <strong className="text-a-light-gray font-medium block capitalize text-[13px]">
                  {fixOptionTitle(v[0])}
                </strong>
                <div className="block text-[12px]">
                  {v[1].map((row) => (
                    <div key={row.value}>
                      {row.value}
                      {row.disclaimers.length > 0 && (
                        <span className="text-gray-600 text-[12px]">
                          {' '}
                          ({row.disclaimers.join(', ')})
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
      </div>

      <div className="pb-4 pt-2">
        {Object.keys(specs).length > 4 && (
          <a
            cy-test-id="more-specs-link"
            className="text-a-blue font-medium text-[14px] cursor-pointer"
            onClick={() => {
              setSpecsOpen(true);
            }}
          >
            More Specs <DownChevronIcon className="inline ml-1" />
          </a>
        )}
      </div>

      <Dialog
        open={specsOpen}
        onClose={() => {
          setSpecsOpen(false);
        }}
        className="relative z-50"
      >
        <div className="fixed inset-0 overflow-y-auto flex items-center justify-center bg-black/60 p-4">
          <Dialog.Panel className="w-full max-w-[600px]">
            <div className="unlock-modal bg-gray-900 shadow-lg drop-shadow-lg py-6 px-6 sm:py-6 sm:px-10 text-white rounded-[10px] w-full">
              <div className='flex items-start md:items-center justify-between mb-4'>
                <h3 className="eurostile uppercase text-lg sm:text-[20px] font-semibold pr-4">
                  Collection Specifications
                </h3>
                <button className='text-white' onClick={() => setSpecsOpen(false)}>
                  <ExitIcon className="w-5 sm:w-6" />
                </button>
              </div>
              <div className="flex flex-col gap-4 my-4 sm:my-6 overflow-y-auto max-h-[calc(100vh-200px)]">
                <table className="w-full">
                  <tbody>
                    {Object.entries(specs).map((v) => (
                      <tr className="w-full" key={v[0]}>
                        <td className="capitalize leading-tight text-[#7e888c] text-xs sm:text-sm font-semibold sm:w-[122px]">
                          {fixOptionTitle(v[0])}:
                        </td>
                        <td className="capitalize px-2 sm:px-3 py-1.5 text-white text-xs sm:text-[14px]">
                          {v[1].map((row, k) => (
                            <span key={row.value}>
                              {k !== 0 && <span className="text-gray-600 text-xs sm:text-sm"> / </span>}
                              <span dangerouslySetInnerHTML={{ __html: row.value }}></span>
                              {row.disclaimers.length > 0 && (
                                <span className="text-gray-600 text-xs sm:text-sm">
                                  {' '}
                                  ({row.disclaimers.join(', ')})
                                </span>
                              )}
                            </span>
                          ))}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </div>
  );
}
